export default __webpack_public_path__ + "static/media/BOEHRINGERLOGO.d2e1e1bf.png";